import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card card-stretch gutter-b" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "row g-5 g-xxl-8" }
const _hoisted_4 = { class: "col-md-8 col-lg-12 col-xxl-8" }
const _hoisted_5 = { class: "col-md-4 col-lg-12 col-xxl-4" }
const _hoisted_6 = { class: "card card-stretch mb-5 mb-xxl-8" }
const _hoisted_7 = { class: "card-body d-flex flex-column rounded bg-light-success justify-content-between" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "rounded text-center mb-7 pt-7" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/products/14.png",
    class: "mw-100 w-200px",
    style: {"transform":"scale(1.4)"}
  })
], -1)
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "fs-2x" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "fs-3 text-success" }, "Amazing Backpack", -1)
const _hoisted_12 = { class: "row g-5 g-xxl-8" }
const _hoisted_13 = { class: "col-md-4 col-lg-12 col-xxl-4" }
const _hoisted_14 = { class: "card" }
const _hoisted_15 = { class: "card-body d-flex flex-column rounded bg-light justify-content-between" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "text-center rounded mb-7" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/products/15.png",
    class: "mw-100 w-200px"
  })
], -1)
const _hoisted_17 = { class: "text-center" }
const _hoisted_18 = { class: "fs-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted fw-bolder" }, "$370.00", -1)
const _hoisted_20 = { class: "col-md-4 col-lg-12 col-xxl-4" }
const _hoisted_21 = { class: "card" }
const _hoisted_22 = { class: "card-body d-flex flex-column rounded bg-light justify-content-between" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "text-center rounded mb-7" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/products/16.png",
    class: "mw-100 w-200px"
  })
], -1)
const _hoisted_24 = { class: "text-center" }
const _hoisted_25 = { class: "fs-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted fw-bolder" }, "$370.00", -1)
const _hoisted_27 = { class: "col-md-4 col-lg-12 col-xxl-4" }
const _hoisted_28 = { class: "card" }
const _hoisted_29 = { class: "card-body d-flex flex-column rounded bg-light justify-content-between" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "text-center rounded mb-7" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/products/17.png",
    class: "mw-100 w-200px"
  })
], -1)
const _hoisted_31 = { class: "text-center" }
const _hoisted_32 = { class: "fs-4" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted fw-bolder" }, "$370.00", -1)
const _hoisted_34 = { class: "col-md-4 col-lg-12 col-xxl-4" }
const _hoisted_35 = { class: "card" }
const _hoisted_36 = { class: "card-body d-flex flex-column rounded bg-light justify-content-between" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "text-center rounded mb-7" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/products/18.png",
    class: "mw-100 w-200px"
  })
], -1)
const _hoisted_38 = { class: "text-center" }
const _hoisted_39 = { class: "fs-4" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted fw-bolder" }, "$370.00", -1)
const _hoisted_41 = { class: "col-md-4 col-lg-12 col-xxl-4" }
const _hoisted_42 = { class: "card" }
const _hoisted_43 = { class: "card-body d-flex flex-column rounded bg-light justify-content-between" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "text-center rounded mb-7" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/products/19.png",
    class: "mw-100 w-200px"
  })
], -1)
const _hoisted_45 = { class: "text-center" }
const _hoisted_46 = { class: "fs-4" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted fw-bolder" }, "$370.00", -1)
const _hoisted_48 = { class: "col-md-4 col-lg-12 col-xxl-4" }
const _hoisted_49 = { class: "card" }
const _hoisted_50 = { class: "card-body d-flex flex-column rounded bg-light justify-content-between" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "text-center rounded mb-7" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "media/products/20.png",
    class: "mw-100 w-200px"
  })
], -1)
const _hoisted_52 = { class: "text-center" }
const _hoisted_53 = { class: "fs-4" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("div", { class: "fs-6 text-muted fw-bolder" }, "$370.00", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EngageWidget1 = _resolveComponent("EngageWidget1")!
  const _component_EngageWidget2 = _resolveComponent("EngageWidget2")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_EngageWidget1, {
        bgImage: "media/illustrations/poa-bg.jpg",
        lg: false,
        bgHex: "#e9f1e3",
        margin: "mb-5 mb-xxl-8"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_EngageWidget2, {
            color: "danger",
            image: "media/products/13.png"
          }),
          _createVNode(_component_EngageWidget2, {
            color: "warning",
            image: "media/products/12.png"
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("h3", _hoisted_10, [
                  _createVNode(_component_router_link, {
                    to: "/product",
                    class: "text-dark text-hover-primary fw-bolder"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Kanken")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_11
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("h4", _hoisted_18, [
                  _createVNode(_component_router_link, {
                    to: "/product",
                    class: "text-gray-800 text-hover-primary fw-bolder"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Bose Headphones 700")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_19
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("h4", _hoisted_25, [
                  _createVNode(_component_router_link, {
                    to: "/product",
                    class: "text-gray-800 text-hover-primary fw-bolder"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Amazon Bip Home")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_26
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _hoisted_30,
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("h4", _hoisted_32, [
                  _createVNode(_component_router_link, {
                    to: "/product",
                    class: "text-gray-800 text-hover-primary fw-bolder"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Black & White Vases")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_33
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("div", _hoisted_36, [
              _hoisted_37,
              _createElementVNode("div", _hoisted_38, [
                _createElementVNode("h4", _hoisted_39, [
                  _createVNode(_component_router_link, {
                    to: "/product",
                    class: "text-gray-800 text-hover-primary fw-bolder"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Spine Friendly Chair")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_40
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_41, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("div", _hoisted_43, [
              _hoisted_44,
              _createElementVNode("div", _hoisted_45, [
                _createElementVNode("h4", _hoisted_46, [
                  _createVNode(_component_router_link, {
                    to: "/product",
                    class: "text-gray-800 text-hover-primary fw-bolder"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Yellow Kettle")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_47
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createElementVNode("div", _hoisted_50, [
              _hoisted_51,
              _createElementVNode("div", _hoisted_52, [
                _createElementVNode("h4", _hoisted_53, [
                  _createVNode(_component_router_link, {
                    to: "/product",
                    class: "text-gray-800 text-hover-primary fw-bolder"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Amazing Mats")
                    ]),
                    _: 1
                  })
                ]),
                _hoisted_54
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}